export class SteamLobby {
    private isConnected = true;

    constructor(public lobbyId: string) {
    }

    getLobbyId(): string | null {
        return this.lobbyId;
    }

    async getLobbyMembers(): Promise<Array<{ name: string, steamId: string }>> {
        if (!this.isConnected || !window.electronApi?.getSteamLobbyMembers) {
            return [];
        }
        return await window.electronApi.getSteamLobbyMembers();
    }

    getLobbyHost() {
        if (!this.isConnected || !window.electronApi?.getSteamLobbyOwner) {
            return false;
        }
        return window.electronApi.getSteamLobbyOwner();
    }

    leave(): void {
        if (window.electronApi?.leaveSteamLobby) {
            window.electronApi.leaveSteamLobby();
        }

        this.isConnected = false;
    }

}
export async function openSteamInviteDialog(): Promise<boolean> {
    return !!(await window.electronApi?.openSteamInviteDialog?.());
}

export async function isSteamAvailable(): Promise<boolean> {
    return !!(await window.electronApi?.isSteamAvailable?.());
}

export async function createSteamLobby(maxMembers: number = 2, lobbyType: string = 'public') {
    try {
        if (!window.electronApi?.createSteamLobby) {
            console.error("SteamLobby: Tried to create lobby but steam API not available");
            return null;
        }

        const result = await window.electronApi.createSteamLobby(maxMembers, lobbyType);
        if (result) {
            const lobbyId = result as string;
            console.log(`Steam lobby created: ${lobbyId}`);
            const host = new SteamLobby(lobbyId);
            return host;
        }
        else {
            return null;
        }

    } catch (error) {
        console.error("Failed to create Steam lobby:", error);
        return null;
    }
}

export async function joinSteamLobby(lobbyId: string) {
    try {

        if (!window.electronApi?.joinSteamLobby) {
            console.error("SteamLobby: Tried to join lobby but steam API not available");
            return null;
        }

        const success = await window.electronApi.joinSteamLobby(lobbyId);
        if (success) {
            const client = new SteamLobby(lobbyId);
            console.log(`Joined Steam lobby: ${lobbyId}`);
            return client;
        }
        else {
            console.log("not success");
            return null;
        }

    } catch (error) {
        console.error("Failed to join Steam lobby:", error);
        return null;
    }
}

export function leaveCurrentSteamLobby() {
    if (window.electronApi?.leaveSteamLobby) {
        window.electronApi.leaveSteamLobby();
    }
}